import { action } from 'satcheljs';
import { PopoutChildState } from '../store/schema/PopoutChildStore';

export default action('setPopoutChildState', (state: PopoutChildState) => ({
    state,
}));
